// copied and edited from packages/ui/src/components/FlavorFinder/components/Buttons/FlavorFinderButtons.tsx
import type { FC } from "react";

import classNames from "classnames";

import { ArrowBackwardIcon } from "@jti/brand-icons/arrow-backward";
import { ReplayIcon } from "@jti/brand-icons/replay";
import { Button } from "@jti/core-components/components/Button";

import styles from "./FlavorFinderButtons.module.scss";

type FlavorFinderQuizButtonProps = {
  onClick: () => void;
  label: string;
  disabled?: boolean;
  hidden?: boolean;
  primaryButton?: boolean;
  mobileHidden?: boolean;
  className?: string;
};

type FlavorFinderAnswerButtonProps = {
  title: string;
  subtitle?: string;
  isActive?: boolean;
};

export const FlavorFinderNextButton: FC<FlavorFinderQuizButtonProps> = ({
  onClick,
  label,
  disabled,
  hidden,
  primaryButton,
  className,
}) => {
  return (
    <Button
      data-testid="flavor-finder-next-button"
      disabled={disabled}
      variant={primaryButton ? "primary" : "secondary"}
      onClick={onClick}
      className={classNames({ [styles.hidden]: hidden }, className)}
    >
      {label}
    </Button>
  );
};

export const FlavorFinderBackButton: FC<FlavorFinderQuizButtonProps> = ({
  onClick,
  label,
  mobileHidden,
  className,
}) => {
  return (
    <div className={classNames(styles.buttonPrevious, className, { [styles.mobileHidden]: mobileHidden })}>
      <Button
        onClick={onClick}
        variant="text-muted"
        iconBefore={ArrowBackwardIcon}
        className={styles.button}
        data-testid="flavor-finder-back-button"
      >
        {label}
      </Button>
    </div>
  );
};

export const FlavorFinderResetButton: FC<FlavorFinderQuizButtonProps> = ({
  onClick,
  label,
  mobileHidden,
  className,
}) => {
  return (
    <div className={classNames(styles.buttonReset, className, { [styles.mobileHidden]: mobileHidden })}>
      <Button onClick={onClick} variant="text-muted" iconBefore={ReplayIcon} className={styles.button}>
        {label}
      </Button>
    </div>
  );
};

export const FlavorFinderSkipButton: FC<FlavorFinderQuizButtonProps> = ({
  onClick,
  label,
  primaryButton,
  className,
  disabled,
}) => {
  return (
    //  TODO replace with Button from DS3
    <Button
      data-testid="flavor-finder-skip-button"
      size="md"
      onClick={onClick}
      variant={primaryButton ? "primary" : "secondary"}
      className={className}
      disabled={disabled}
    >
      {label}
    </Button>
  );
};

export const FlavorFinderResultsButton: FC<FlavorFinderQuizButtonProps> = ({ onClick, label }) => {
  return (
    //  TODO replace with Button from DS3
    <Button
      onClick={onClick}
      className={classNames(styles.button, styles.buttonResult)}
      data-testid="flavor-finder-skip-button"
      variant="primary"
    >
      {label}
    </Button>
  );
};

export const FlavorFinderStartQuizButton: FC<FlavorFinderQuizButtonProps> = ({
  onClick,
  label,
  primaryButton,
  className,
}) => {
  return <FlavorFinderNextButton onClick={onClick} label={label} primaryButton={primaryButton} className={className} />;
};

export const FlavorFinderAnswerButton: FC<FlavorFinderAnswerButtonProps> = ({ title, subtitle, isActive }) => {
  return (
    <div
      data-testid="flavor-finder-answer-button"
      className={classNames(styles.buttonAnswer, { [styles.buttonAnswerActive]: isActive })}
    >
      <div className={styles.answerTitle}>{title}</div>
      {subtitle && <div className={styles.answerSubtitle}>{subtitle}</div>}
    </div>
  );
};
